export default onSelectAction => dispatch => dispatch(onSelectAction)
